
import ClickOutside from "vue-click-outside";
import { isEmpty } from "@utils";
import { mapGetters } from "vuex";

export default {
	name: "WordActions",
	directives: {
		ClickOutside,
	},
	props: {
		word: {
			type: Object,
			required: true,
		},
		showKebabMenu: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			menuIsOpen: false,
		};
	},
	computed: {
		...mapGetters("navigation", ["isScrabbleDictionaryResultsPage"]),
		hasDefinition() {
			return !isEmpty(this.word.has_definition);
		},
		shouldShowDefinitionButton() {
			return !this.isScrabbleDictionaryResultsPage;
		},
	},
	methods: {
		onButtonClick() {
			this.menuIsOpen = !this.menuIsOpen;
		},
		onMenuClickOutside(e) {
			const button = this.$refs.button;
			if (button && e.composedPath().includes(button)) {
				return;
			}

			this.menuIsOpen = false;
		},
		onReportButtonClick() {
			this.$store.commit("report-word-dialog/open", this.word.word);
			this.menuIsOpen = false;
		},
	},
};
